import styles from "./Navbar.module.scss";
import { NavLink } from 'react-router-dom';
import { Button } from "../common/Button";
import classNames from "classnames";
import { ModeContext } from "../../context/ModeContext";
import { useContext } from "react";

type isActiveLinkProps = {
  isActive: boolean;
};

type NavBarProps = {
  active?: boolean;
};

const isActiveLink = ({ isActive }: isActiveLinkProps): string =>
  isActive ? styles.activeLink : styles.link;



export const Navbar = ({ active }: NavBarProps) => {
  const { adminMode } = useContext(ModeContext);

  return (
    <aside className={classNames(styles.aside, { [styles.active]: !active })}>
      <div className={styles.image}></div>
      <nav className={styles.nav}>
        <NavLink to='/library/startups' className={isActiveLink}>
          STARTUPS
        </NavLink>
        <NavLink to='/programs' className={isActiveLink}>
        </NavLink>
      </nav>
      <NavLink className={styles.button} to="/logout">
          <Button className='primary' type='button' >
          UITLOGGEN
        </Button>
      </NavLink>
    </aside>
  );
};
